import { useState, useEffect } from 'react';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../config/constants';

export default function useValueForCurrentViewPort(val1, val2, val3, val4, val5) {
  const [ValueForCurrentViewPort, setValueForCurrentViewPort] = useState(val1);
  useEffect(() => {
    function handleResize() {
      const { innerWidth: width } = window;
      // 0 & 768
      if (width >= SCREEN_MOBILE && width < SCREEN_TABLET) {
        setValueForCurrentViewPort(val1);
        return;
      }
      // 768 & 992
      else if (width >= SCREEN_TABLET && width <= SCREEN_NORMAL) {
        setValueForCurrentViewPort(val2);
        return;
      }
      // 992 & 1240
      else if (width >= SCREEN_NORMAL && width <= SCREEN_WIDE) {
        setValueForCurrentViewPort(val3);
        return;
      }
      // 1240 & 2000
      else if (width >= SCREEN_WIDE && width <= SCREEN_HUGE) {
        setValueForCurrentViewPort(val4);
        return;
      }
      // SCREEN_HUGE and larger
      setValueForCurrentViewPort(val5);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [val1, val2, val3, val4, val5]);

  return ValueForCurrentViewPort;
}
